import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import drag from "../../assets/images/icons/dragDots.svg";
import React from "react";

interface Props {
  id: string;
  children: React.ReactNode;
}

const DragAndDropItem: React.FC<Props> = ({ id, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex w-full items-center"
      {...attributes}
    >
      <div
        {...listeners}
        className="me-2 flex-shrink-0 cursor-grab active:cursor-grabbing"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <img src={drag} alt="drag" className="h-6 w-6" />
      </div>

      <div className="flex-1">{children}</div>
    </div>
  );
};
export default DragAndDropItem;
